var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-6 pr-4 pt-2"},[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_c('div',[(!!_vm.isAprove)?_c('aprove-service',{attrs:{"orderService":_vm.orderService}}):_vm._e(),(!_vm.isAprove)?_c('detail-service',{attrs:{"orderService":_vm.orderService}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }